import { Appointment } from "@elixir/types";
import useMarkNoShowMutation from "../../../../apis/tryst/post-mark-no-show";
import { ReactComponent as BanRegularIcon } from "../../../../assets/icons/font-awesome/ban-regular.svg";
import { ChipWithTooltip } from "ui";

const MarkNoShow = ({
  apt,
  className = "",
  type,
}: {
  apt: Appointment;
  className?: string;
  type?: "primary" | "secondary";
}) => {
  const { mutateAsync: postMarkNoShowAppointment } = useMarkNoShowMutation();

  return (
    <ChipWithTooltip
      onClick={() => {
        postMarkNoShowAppointment({ appointment: apt });
      }}
      className={`h-32 flex-1 ${className}`}
      icon={<BanRegularIcon className="dr-min-w-14 dr-h-14" />}
      title="No Show"
      tooltipText="Mark No Show"
      type={type}
    />
  );
};

export default MarkNoShow;
